module.exports = {
	"contractName": "Freeshop",
	"abi": [
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "lastWithdrawTime",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "balances",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "withdrawalLimit",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"payable": true,
			"stateMutability": "payable",
			"type": "fallback"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "depositFunds",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_weiToWithdraw",
					"type": "uint256"
				}
			],
			"name": "withdrawFunds",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "getBalance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		}
	],
	"bytecode": "0x608060405267016345785d8a000060005534801561001c57600080fd5b5061022b8061002c6000396000f3006080604052600436106100775763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416631031ec31811461007957806312065fe0146100b9578063155dd5ee146100ce57806327e235e3146100e65780637ddfe78d14610114578063e2c41dbc14610129575b005b34801561008557600080fd5b506100a773ffffffffffffffffffffffffffffffffffffffff60043516610131565b60408051918252519081900360200190f35b3480156100c557600080fd5b506100a7610143565b3480156100da57600080fd5b50610077600435610148565b3480156100f257600080fd5b506100a773ffffffffffffffffffffffffffffffffffffffff600435166101d0565b34801561012057600080fd5b506100a76101e2565b6100776101e8565b60016020526000908152604090205481565b303190565b3360009081526002602052604090205481111561016457600080fd5b60005481111561017357600080fd5b3360009081526001602052604090205462093a800142101561019457600080fd5b60405133908290600081818185875af1505033600090815260026020908152604080832080549690960390955560019052929092204290555050565b60026020526000908152604090205481565b60005481565b3360009081526002602052604090208054340190555600a165627a7a723058208f46fdd2dffa0524f8355137658235a440baca6f6d1ce6bc92035fe3520122e60029",
	"deployedBytecode": "0x6080604052600436106100775763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416631031ec31811461007957806312065fe0146100b9578063155dd5ee146100ce57806327e235e3146100e65780637ddfe78d14610114578063e2c41dbc14610129575b005b34801561008557600080fd5b506100a773ffffffffffffffffffffffffffffffffffffffff60043516610131565b60408051918252519081900360200190f35b3480156100c557600080fd5b506100a7610143565b3480156100da57600080fd5b50610077600435610148565b3480156100f257600080fd5b506100a773ffffffffffffffffffffffffffffffffffffffff600435166101d0565b34801561012057600080fd5b506100a76101e2565b6100776101e8565b60016020526000908152604090205481565b303190565b3360009081526002602052604090205481111561016457600080fd5b60005481111561017357600080fd5b3360009081526001602052604090205462093a800142101561019457600080fd5b60405133908290600081818185875af1505033600090815260026020908152604080832080549690960390955560019052929092204290555050565b60026020526000908152604090205481565b60005481565b3360009081526002602052604090208054340190555600a165627a7a723058208f46fdd2dffa0524f8355137658235a440baca6f6d1ce6bc92035fe3520122e60029",
	"sourceMap": "26:807:13:-;;;81:9;48:42;;26:807;8:9:-1;5:2;;;30:1;27;20:12;5:2;26:807:13;;;;;;;",
	"deployedSourceMap": "26:807:13:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;94:51;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;94:51:13;;;;;;;;;;;;;;;;;;;;;;;708:91;;8:9:-1;5:2;;;30:1;27;20:12;5:2;708:91:13;;;;284:420;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;284:420:13;;;;;149:43;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;149:43:13;;;;;;;48:42;;8:9:-1;5:2;;;30:1;27;20:12;5:2;48:42:13;;;;197:83;;;;94:51;;;;;;;;;;;;;:::o;708:91::-;781:4;773:21;708:91;:::o;284:420::-;389:10;380:20;;;;:8;:20;;;;;;:38;-1:-1:-1;380:38:13;372:47;;;;;;493:15;;475:33;;;467:42;;;;;;547:10;530:28;;;;:16;:28;;;;;;561:7;530:38;523:3;:45;;515:54;;;;;;576:39;;:10;;598:14;;576:39;;;;598:14;576:10;:39;;-1:-1:-1;;630:10:13;621:20;;;;:8;:20;;;;;;;;:38;;;;;;;;;-1:-1:-1;665:28:13;;;;;;696:3;665:34;;-1:-1:-1;;284:420:13:o;149:43::-;;;;;;;;;;;;;:::o;48:42::-;;;;:::o;197:83::-;251:10;242:20;;;;:8;:20;;;;;:33;;266:9;242:33;;;197:83::o",
	"source": "pragma solidity ^0.4.24;\n\ncontract Freeshop {\n  uint256 public withdrawalLimit = 0.1 ether;\n  mapping(address => uint256) public lastWithdrawTime;\n  mapping(address => uint256) public balances;\n\n  function depositFunds() public payable {\n    balances[msg.sender] += msg.value;\n  }\n\n  function withdrawFunds(uint256 _weiToWithdraw) public {\n    // limit the withdrawal\n    require(balances[msg.sender] >= _weiToWithdraw);\n    // limit the time allowed to withdraw\n    require(_weiToWithdraw <= withdrawalLimit);\n    require(now >= lastWithdrawTime[msg.sender] + 1 weeks);\n\n    msg.sender.call.value(_weiToWithdraw)();\n    balances[msg.sender] -= _weiToWithdraw;\n    lastWithdrawTime[msg.sender] = now;\n  }\n\n  function getBalance() public view returns (uint256) {\n    return address(this).balance;\n  }\n\n  function() public payable {}\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Freeshop.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Freeshop.sol",
		"exportedSymbols": {
			"Freeshop": [
				1441
			]
		},
		"id": 1442,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1345,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:13"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1441,
				"linearizedBaseContracts": [
					1441
				],
				"name": "Freeshop",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1348,
						"name": "withdrawalLimit",
						"nodeType": "VariableDeclaration",
						"scope": 1441,
						"src": "48:42:13",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1346,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "48:7:13",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "302e31",
							"id": 1347,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "81:9:13",
							"subdenomination": "ether",
							"typeDescriptions": {
								"typeIdentifier": "t_rational_100000000000000000_by_1",
								"typeString": "int_const 100000000000000000"
							},
							"value": "0.1"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1352,
						"name": "lastWithdrawTime",
						"nodeType": "VariableDeclaration",
						"scope": 1441,
						"src": "94:51:13",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 1351,
							"keyType": {
								"id": 1349,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "102:7:13",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "94:27:13",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 1350,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "113:7:13",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1356,
						"name": "balances",
						"nodeType": "VariableDeclaration",
						"scope": 1441,
						"src": "149:43:13",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 1355,
							"keyType": {
								"id": 1353,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "157:7:13",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "149:27:13",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 1354,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "168:7:13",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1367,
							"nodeType": "Block",
							"src": "236:44:13",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1365,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1359,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1356,
												"src": "242:8:13",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 1362,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1360,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "251:3:13",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1361,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "251:10:13",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "242:20:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "+=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1363,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "266:3:13",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 1364,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "value",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "266:9:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "242:33:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1366,
									"nodeType": "ExpressionStatement",
									"src": "242:33:13"
								}
							]
						},
						"documentation": null,
						"id": 1368,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "depositFunds",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1357,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "218:2:13"
						},
						"payable": true,
						"returnParameters": {
							"id": 1358,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "236:0:13"
						},
						"scope": 1441,
						"src": "197:83:13",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1424,
							"nodeType": "Block",
							"src": "338:366:13",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1379,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 1374,
														"name": "balances",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1356,
														"src": "380:8:13",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 1377,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1375,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "389:3:13",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1376,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "389:10:13",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "380:20:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 1378,
													"name": "_weiToWithdraw",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1370,
													"src": "404:14:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "380:38:13",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1373,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "372:7:13",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1380,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "372:47:13",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1381,
									"nodeType": "ExpressionStatement",
									"src": "372:47:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1385,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1383,
													"name": "_weiToWithdraw",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1370,
													"src": "475:14:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "<=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 1384,
													"name": "withdrawalLimit",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1348,
													"src": "493:15:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "475:33:13",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1382,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "467:7:13",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1386,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "467:42:13",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1387,
									"nodeType": "ExpressionStatement",
									"src": "467:42:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1396,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1389,
													"name": "now",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2939,
													"src": "523:3:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1395,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1390,
															"name": "lastWithdrawTime",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1352,
															"src": "530:16:13",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
																"typeString": "mapping(address => uint256)"
															}
														},
														"id": 1393,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1391,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "547:3:13",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 1392,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "547:10:13",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "530:28:13",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "+",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 1394,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "561:7:13",
														"subdenomination": "weeks",
														"typeDescriptions": {
															"typeIdentifier": "t_rational_604800_by_1",
															"typeString": "int_const 604800"
														},
														"value": "1"
													},
													"src": "530:38:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "523:45:13",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1388,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "515:7:13",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1397,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "515:54:13",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1398,
									"nodeType": "ExpressionStatement",
									"src": "515:54:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1406,
													"name": "_weiToWithdraw",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1370,
													"src": "598:14:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1399,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "576:3:13",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1403,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "576:10:13",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"id": 1404,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "call",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "576:15:13",
													"typeDescriptions": {
														"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$",
														"typeString": "function () payable returns (bool)"
													}
												},
												"id": 1405,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "576:21:13",
												"typeDescriptions": {
													"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_barecall_payable$__$returns$_t_bool_$value_$",
													"typeString": "function (uint256) returns (function () payable returns (bool))"
												}
											},
											"id": 1407,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "576:37:13",
											"typeDescriptions": {
												"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$value",
												"typeString": "function () payable returns (bool)"
											}
										},
										"id": 1408,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "576:39:13",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1409,
									"nodeType": "ExpressionStatement",
									"src": "576:39:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1415,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1410,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1356,
												"src": "621:8:13",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 1413,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1411,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "630:3:13",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1412,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "630:10:13",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "621:20:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "-=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1414,
											"name": "_weiToWithdraw",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1370,
											"src": "645:14:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "621:38:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1416,
									"nodeType": "ExpressionStatement",
									"src": "621:38:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1422,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1417,
												"name": "lastWithdrawTime",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1352,
												"src": "665:16:13",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 1420,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1418,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "682:3:13",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1419,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "682:10:13",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "665:28:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1421,
											"name": "now",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2939,
											"src": "696:3:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "665:34:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1423,
									"nodeType": "ExpressionStatement",
									"src": "665:34:13"
								}
							]
						},
						"documentation": null,
						"id": 1425,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "withdrawFunds",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1371,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1370,
									"name": "_weiToWithdraw",
									"nodeType": "VariableDeclaration",
									"scope": 1425,
									"src": "307:22:13",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1369,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "307:7:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "306:24:13"
						},
						"payable": false,
						"returnParameters": {
							"id": 1372,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "338:0:13"
						},
						"scope": 1441,
						"src": "284:420:13",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1435,
							"nodeType": "Block",
							"src": "760:39:13",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1431,
													"name": "this",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2982,
													"src": "781:4:13",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Freeshop_$1441",
														"typeString": "contract Freeshop"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_contract$_Freeshop_$1441",
														"typeString": "contract Freeshop"
													}
												],
												"id": 1430,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "773:7:13",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 1432,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "773:13:13",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 1433,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "balance",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "773:21:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 1429,
									"id": 1434,
									"nodeType": "Return",
									"src": "766:28:13"
								}
							]
						},
						"documentation": null,
						"id": 1436,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getBalance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1426,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "727:2:13"
						},
						"payable": false,
						"returnParameters": {
							"id": 1429,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1428,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1436,
									"src": "751:7:13",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1427,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "751:7:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "750:9:13"
						},
						"scope": 1441,
						"src": "708:91:13",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1439,
							"nodeType": "Block",
							"src": "829:2:13",
							"statements": []
						},
						"documentation": null,
						"id": 1440,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1437,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "811:2:13"
						},
						"payable": true,
						"returnParameters": {
							"id": 1438,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "829:0:13"
						},
						"scope": 1441,
						"src": "803:28:13",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1442,
				"src": "26:807:13"
			}
		],
		"src": "0:834:13"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Freeshop.sol",
		"exportedSymbols": {
			"Freeshop": [
				1441
			]
		},
		"id": 1442,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1345,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:13"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1441,
				"linearizedBaseContracts": [
					1441
				],
				"name": "Freeshop",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1348,
						"name": "withdrawalLimit",
						"nodeType": "VariableDeclaration",
						"scope": 1441,
						"src": "48:42:13",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1346,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "48:7:13",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "302e31",
							"id": 1347,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "81:9:13",
							"subdenomination": "ether",
							"typeDescriptions": {
								"typeIdentifier": "t_rational_100000000000000000_by_1",
								"typeString": "int_const 100000000000000000"
							},
							"value": "0.1"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1352,
						"name": "lastWithdrawTime",
						"nodeType": "VariableDeclaration",
						"scope": 1441,
						"src": "94:51:13",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 1351,
							"keyType": {
								"id": 1349,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "102:7:13",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "94:27:13",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 1350,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "113:7:13",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1356,
						"name": "balances",
						"nodeType": "VariableDeclaration",
						"scope": 1441,
						"src": "149:43:13",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 1355,
							"keyType": {
								"id": 1353,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "157:7:13",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "149:27:13",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 1354,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "168:7:13",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1367,
							"nodeType": "Block",
							"src": "236:44:13",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1365,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1359,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1356,
												"src": "242:8:13",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 1362,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1360,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "251:3:13",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1361,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "251:10:13",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "242:20:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "+=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1363,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "266:3:13",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 1364,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "value",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "266:9:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "242:33:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1366,
									"nodeType": "ExpressionStatement",
									"src": "242:33:13"
								}
							]
						},
						"documentation": null,
						"id": 1368,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "depositFunds",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1357,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "218:2:13"
						},
						"payable": true,
						"returnParameters": {
							"id": 1358,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "236:0:13"
						},
						"scope": 1441,
						"src": "197:83:13",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1424,
							"nodeType": "Block",
							"src": "338:366:13",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1379,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 1374,
														"name": "balances",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1356,
														"src": "380:8:13",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 1377,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1375,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "389:3:13",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1376,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "389:10:13",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "380:20:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 1378,
													"name": "_weiToWithdraw",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1370,
													"src": "404:14:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "380:38:13",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1373,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "372:7:13",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1380,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "372:47:13",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1381,
									"nodeType": "ExpressionStatement",
									"src": "372:47:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1385,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1383,
													"name": "_weiToWithdraw",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1370,
													"src": "475:14:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "<=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 1384,
													"name": "withdrawalLimit",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1348,
													"src": "493:15:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "475:33:13",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1382,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "467:7:13",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1386,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "467:42:13",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1387,
									"nodeType": "ExpressionStatement",
									"src": "467:42:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1396,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1389,
													"name": "now",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2939,
													"src": "523:3:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1395,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 1390,
															"name": "lastWithdrawTime",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1352,
															"src": "530:16:13",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
																"typeString": "mapping(address => uint256)"
															}
														},
														"id": 1393,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1391,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "547:3:13",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 1392,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "547:10:13",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "530:28:13",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "+",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 1394,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "561:7:13",
														"subdenomination": "weeks",
														"typeDescriptions": {
															"typeIdentifier": "t_rational_604800_by_1",
															"typeString": "int_const 604800"
														},
														"value": "1"
													},
													"src": "530:38:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "523:45:13",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1388,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "515:7:13",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1397,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "515:54:13",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1398,
									"nodeType": "ExpressionStatement",
									"src": "515:54:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1406,
													"name": "_weiToWithdraw",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1370,
													"src": "598:14:13",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1399,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "576:3:13",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1403,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "576:10:13",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"id": 1404,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "call",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "576:15:13",
													"typeDescriptions": {
														"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$",
														"typeString": "function () payable returns (bool)"
													}
												},
												"id": 1405,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "576:21:13",
												"typeDescriptions": {
													"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_barecall_payable$__$returns$_t_bool_$value_$",
													"typeString": "function (uint256) returns (function () payable returns (bool))"
												}
											},
											"id": 1407,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "576:37:13",
											"typeDescriptions": {
												"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$value",
												"typeString": "function () payable returns (bool)"
											}
										},
										"id": 1408,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "576:39:13",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1409,
									"nodeType": "ExpressionStatement",
									"src": "576:39:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1415,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1410,
												"name": "balances",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1356,
												"src": "621:8:13",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 1413,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1411,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "630:3:13",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1412,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "630:10:13",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "621:20:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "-=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1414,
											"name": "_weiToWithdraw",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1370,
											"src": "645:14:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "621:38:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1416,
									"nodeType": "ExpressionStatement",
									"src": "621:38:13"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1422,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1417,
												"name": "lastWithdrawTime",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1352,
												"src": "665:16:13",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 1420,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1418,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "682:3:13",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1419,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "682:10:13",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "665:28:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1421,
											"name": "now",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2939,
											"src": "696:3:13",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "665:34:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1423,
									"nodeType": "ExpressionStatement",
									"src": "665:34:13"
								}
							]
						},
						"documentation": null,
						"id": 1425,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "withdrawFunds",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1371,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1370,
									"name": "_weiToWithdraw",
									"nodeType": "VariableDeclaration",
									"scope": 1425,
									"src": "307:22:13",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1369,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "307:7:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "306:24:13"
						},
						"payable": false,
						"returnParameters": {
							"id": 1372,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "338:0:13"
						},
						"scope": 1441,
						"src": "284:420:13",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1435,
							"nodeType": "Block",
							"src": "760:39:13",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1431,
													"name": "this",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2982,
													"src": "781:4:13",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Freeshop_$1441",
														"typeString": "contract Freeshop"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_contract$_Freeshop_$1441",
														"typeString": "contract Freeshop"
													}
												],
												"id": 1430,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "773:7:13",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 1432,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "773:13:13",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 1433,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "balance",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "773:21:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 1429,
									"id": 1434,
									"nodeType": "Return",
									"src": "766:28:13"
								}
							]
						},
						"documentation": null,
						"id": 1436,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getBalance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1426,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "727:2:13"
						},
						"payable": false,
						"returnParameters": {
							"id": 1429,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1428,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1436,
									"src": "751:7:13",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1427,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "751:7:13",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "750:9:13"
						},
						"scope": 1441,
						"src": "708:91:13",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1439,
							"nodeType": "Block",
							"src": "829:2:13",
							"statements": []
						},
						"documentation": null,
						"id": 1440,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1437,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "811:2:13"
						},
						"payable": true,
						"returnParameters": {
							"id": 1438,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "829:0:13"
						},
						"scope": 1441,
						"src": "803:28:13",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1442,
				"src": "26:807:13"
			}
		],
		"src": "0:834:13"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.802Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Freeshop.json
// module id = 1039
// module chunks = 0